<div class="filters-box">
  <app-select-search
    [items]="types"
    bindValue="value"
    bindLabel="label"
    placeholder="Type"
    i18n-placeholder
    i18n-matTooltip
    matTooltip="Filter by templates that are with the selected type(s)."
    [ctrl]="filters.get('type')"
  ></app-select-search>
  <app-select-search
    [items]="tags$ | async"
    i18n-placeholder
    i18n-matTooltip
    placeholder="Tags"
    matTooltip="Filter by templates that are assigned the specified tag(s)."
    [ctrl]="filters.get('tags')"
  ></app-select-search>
  <app-cancel-filters [filterControl]="filters" [isFiltering]="filters | isFiltering"></app-cancel-filters>
  <div class="flex-fill"></div>
  <app-table-search [ctrl]="filters.get('search')" (search)="onSearch($event)"></app-table-search>

  <div dropdown [isDisabled]="1 | isReadonlyRole" class="dropdown">
    <button type="button" class="btn btn-secondary-warning" dropdownToggle>
      <i class="cs-icon cs-icon-bolt"></i> <ng-container i18n>Actions</ng-container>
    </button>

    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
      <li>
        <a
          i18n-matTooltip
          matTooltip="Download the selected templates."
          matTooltipPosition="left"
          (click)="onDownloadSelected()"
        >
          <i class="cs-icon cs-icon-download"></i> <ng-container i18n>Download</ng-container>
        </a>
      </li>
      <li>
        <a
          i18n-matTooltip
          matTooltip="Delete the selected templates."
          matTooltipPosition="left"
          (click)="onDeleteSelected()"
        >
          <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
        </a>
      </li>
    </ul>
  </div>
</div>
<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDirection="desc" #matTable>
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="position-relative" (click)="$event.stopPropagation()">
          <mat-checkbox (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <div title="Created" i18n>Created</div>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div title="{{ element.created | epoch }}" class="text-truncate">{{ element.created | epoch }}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div [matTooltip]="element.name" class="text-truncate">{{ element.name }}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="typeView">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="text-truncate text-capitalize">
            <i [ngClass]="element.type | templateIcon : true" class="column-icon-prefix"></i>
            {{ element.typeView }}
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="roles">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Roles</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div matTooltip="{{ element.roles }}" class="text-truncate">
            {{ element.roles }}
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef>
          <app-table-column-manager
            tableId="contract-templates"
            [displayedColumns]="displayedColumns"
            (columnsChanged)="displayedColumns = $event"
          ></app-table-column-manager>
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index" (click)="$event.stopPropagation()">
          <div dropdown container="body" placement="bottom right" class="dropdown">
            <a href="javascript:;" class="btn-ellips" dropdownToggle>
              <i class="fas fa-ellipsis-h action-icon"></i>
            </a>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <a
                  i18n-matTooltip
                  matTooltip="Edit this template. You can change all settings, including the name, signers, fields, and message."
                  matTooltipPosition="left"
                  (click)="onEdit(element)"
                >
                  <i class="far fa-edit fa-fw" aria-hidden="true"></i> <ng-container i18n>Edit</ng-container>
                </a>
              </li>
              <li>
                <a
                  i18n-matTooltip
                  matTooltip="Edit this template's settings."
                  matTooltipPosition="left"
                  (click)="onPrepare(element)"
                >
                  <i class="far fa-signature fa-fw" aria-hidden="true"></i>
                  <ng-container i18n>Prepare</ng-container>
                </a>
              </li>
              <li>
                <a
                  i18n-matTooltip
                  matTooltip="Send this template to a guest, an account user, or a one-off signer of your own choosing."
                  matTooltipPosition="left"
                  *ngIf="isReadyToUse(element)"
                  (click)="onSend(element)"
                >
                  <i class="far fa-paper-plane fa-fw" aria-hidden="true"></i>
                  <ng-container i18n>Send</ng-container>
                </a>
              </li>
              <li>
                <a (click)="onPreview(element)"> <i class="far fa-eye fa-fw" aria-hidden="true"></i> Preview </a>
              </li>
              <li>
                <a
                  i18n-matTooltip
                  matTooltip="Edit the name of this template."
                  matTooltipPosition="left"
                  (click)="onRename(element)"
                >
                  <i class="far fa-edit fa-fw" aria-hidden="true"></i> <ng-container i18n>Rename</ng-container>
                </a>
              </li>

              <li>
                <a
                  i18n-matTooltip
                  matTooltip="Download this template as a PDF."
                  matTooltipPosition="left"
                  (click)="onDownload(element)"
                >
                  <i class="far fa-cloud-download fa-fw" aria-hidden="true"></i>
                  <ng-container i18n>Download</ng-container>
                </a>
              </li>
              <li>
                <a
                  i18n-matTooltip
                  matTooltip="Permanently delete this template from your account."
                  matTooltipPosition="left"
                  (click)="onDelete(element)"
                >
                  <i class="far fa-trash-alt fa-fw" aria-hidden="true"></i>
                  <ng-container i18n>Delete</ng-container>
                </a>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="cursor-pointer"
        [attr.data-template]="row.id"
        (click)="onEdit(row)"
      >
      </mat-row>
    </mat-table>

    <app-empty-table *ngIf="isEmptyTable$ | async" [isFiltering]="filters | isFiltering" type="SignatureTemplates">
      <p>
        <a href="javascript:;" (click)="onAdd()" *ngIf="!(1 | isReadonlyRole)" i18n>Click here</a>&nbsp;<ng-container
          i18n
          >to create your first template and simplify your document processes today.</ng-container
        >
      </p>
    </app-empty-table>

    <mat-paginator2
      #paginator
      [length]="dataSource?.filteredData?.length"
      [class.hidden]="isEmptyTable$ | async"
      pageSize="10"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>
  </table>
</div>
